import { ProjectActions } from '@octopus-do/octopus-project-core'
import { commitProjectRequest } from '@storeOld/actionCreators'

import API from '@/api'
import { NotificationType, notificationActionCreators } from './notification'

export const clearBlockImage = () => (dispatch, getState) => {
  const { canvas } = getState()

  const selectedIds = canvas.block.ids

  dispatch(
    commitProjectRequest(
      ProjectActions.blocks.updateVisual({
        ids: selectedIds,
        visual: {
          type: 'wireframes',
          wireframes: [],
        },
      })
    )
  )
}

export const uploadImage = (file) => (dispatch, getState) => {
  const {
    canvas,
    manager: {
      meta: { id },
    },
  } = getState()

  return new Promise((resolve, reject) => {
    API.Image.upload({ projectId: id, file })
      .then((response) => {
        const selectedIds = canvas.block.ids

        dispatch(
          commitProjectRequest(
            ProjectActions.blocks.updateVisual({
              ids: selectedIds,
              visual: {
                type: 'image',
                image: response,
              },
            })
          )
        )

        return resolve(file)
      })
      .catch((error) => {
        dispatch(
          notificationActionCreators.setNotification({
            type: NotificationType.UPLOAD_ERROR,
          })
        )

        setTimeout(() => {
          dispatch(
            notificationActionCreators.setClearNotification({
              toastContainerId: 'main',
            })
          )
        }, 3000)

        return reject(error)
      })
  })
}
